module.exports = __webpack_public_path__ + "media/images/map-icons/mapbox-sattelite-6611552b388da145a67077f0f4e883ed.png";